import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { HeaderService } from 'src/app/header/header.service';
import { TranslateService } from '@ngx-translate/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-header-langs-dropdown',
  templateUrl: './header-langs-dropdown.component.html',
  styleUrls: ['./header-langs-dropdown.component.scss']
})
export class HeaderLangsDropdownComponent implements OnInit {

  public show: boolean;
  private headerComponents: Array<any>;
  currentLang;
  private langs = [
                    { code: 'en_GB', icon: './assets/icons/flag_uk.png' },
                    { code: 'es_ES', icon: './assets/icons/flag_es.png' },
                    { code: 'fr_FR', icon: './assets/icons/flag_fr.png' },
                    { code: 'de_DE', icon: './assets/icons/flag_de.png' },
                    { code: 'pt_PT', icon: './assets/icons/flag_pt.png' },
                    { code: 'el_GR', icon: './assets/icons/flag_gr.png' },
                    { code: 'tr_TR', icon: './assets/icons/flag_tr.png' },
                  ];

  constructor(private eRef: ElementRef,
              private userStorageService: UserStorageService,
              private headerService: HeaderService,
              private translateService: TranslateService) { }

  ngOnInit() {
    this.headerService.setAsHeaderComponent(this);
    this.headerService.listen().subscribe(
      (res) => {
        this.headerComponents = res;
        this.headerComponents.forEach(
          (e) => {
            if (e['component'] === this) {
              this.show = e['show'];
            }
          }
        );
      }
    );
    this.currentLang = this.setCurrentLang(this.userStorageService.getLang());
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if ((!this.eRef.nativeElement.contains(event.target)) && (this.show)) {
      this.toggle();
    }
  }

  public toggle() {
    this.headerService.toggle(this);
  }

  public doAction(action) {
    eval(action);
  }

  public changeLang(lang) {
    this.userStorageService.setLang(lang.code);
    this.currentLang = lang;
    this.translateService.use(lang.code);
    this.toggle();
  }

  private setCurrentLang(langCode) {
    const a = this.langs.filter(
      (lang) => {
        return lang.code === langCode;
      }
    );
    return a[0];
  }

}
